/**
 * Buy/Sell tab disabled + tooltip state shared by the secondary-market trade
 * Modal and Drawer variants (TradeModal.js / TradeDrawer.js).
 */
export const computeSecondaryTradeTabState = ({
  userPurchasedShare,
  isSellOrdersTradable,
  isSellEligible,
  sellIneligibleMsg,
  isTradeFlow,
  isBuyEligible,
  buyIneligibleMsg,
  isEntityRestricted,
}) => {
  const sellTabDisabled = !userPurchasedShare || !isSellOrdersTradable || !isSellEligible;
  const sellTabTooltip = isEntityRestricted
    ? sellIneligibleMsg
    : !userPurchasedShare
    ? ''
    : !isSellEligible
    ? sellIneligibleMsg
    : !isSellOrdersTradable
    ? 'You cannot create this sell order because some or all of your shares are already placed in open sell orders.'
    : '';

  // Only the Trade button flow (Portfolio) gates the Buy tab on eligibility;
  // Buy Now (home page) and Buy (property details page) keep prior behavior.
  // Entity accounts are restricted from the Secondary Marketplace regardless
  // of which flow they entered through (RDS-921).
  const buyTabDisabled = isEntityRestricted || (isTradeFlow && !isBuyEligible);
  const buyTabTooltip = buyTabDisabled ? buyIneligibleMsg : '';

  return { sellTabDisabled, sellTabTooltip, buyTabDisabled, buyTabTooltip };
};
